/**
 * helper to handle request cancelling (request identification using id)
 */
export class AsynchronousRequest {

  /**
   * Id count
   */
  public static idCount = 0;

  /**
   * Id of the request
   */
  public id;

  /**
   * if the request can be cancelled
   */
  cancellable: boolean;

  /**
   * default constructor, just determine the Request ID and update Count
   */
  constructor(cancellable: boolean) {
    this.cancellable = cancellable;
    this.id = AsynchronousRequest.idCount;
    AsynchronousRequest.idCount++;
  }
}
